import {BranchAndTagCountProvider} from '@github-ui/code-view-shared/contexts/BranchAndTagContext'
import {CommitInfoProvider} from '@github-ui/code-view-shared/contexts/CommitInfoContext'
import {LatestCommitProvider} from '@github-ui/code-view-shared/contexts/LatestCommitContext'
import {RecentlyTouchedBranchesProvider} from '@github-ui/code-view-shared/contexts/RecentlyTouchedBranchesContext'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'

import type {MergedHeaderPayload} from '../components/overview/OverviewHeader'
import {SharedPageLayout} from '../components/SharedPageLayout'
import {codeViewRepoRoute} from '../routes/code-view-repo-route'
import {ReposOverviewPage} from './ReposOverviewPage'

export function CodeViewRepoEntrypoint() {
  const {data: payload} = useRouteQuery(codeViewRepoRoute, 'mainQuery')
  const {
    data: latestCommit,
    error: latestCommitError,
    isLoading: latestCommitLoading,
  } = useRouteQuery(codeViewRepoRoute, 'latestCommit')
  const {
    data: commitInfo,
    error: commitInfoError,
    isLoading: commitInfoLoading,
  } = useRouteQuery(codeViewRepoRoute, 'treeCommitInfo')
  const {data: recentlyTouchedBranches, refetch: refetchBranches} = useRouteQuery(
    codeViewRepoRoute,
    'recentlyTouchedBranches',
  )
  const {data: branchAndTagCount} = useRouteQuery(codeViewRepoRoute, 'branchAndTagCount')
  const {data: sidebarAbout, queryKey: sidebarAboutQueryKey} = useRouteQuery(codeViewRepoRoute, 'sidebarAbout')

  const sidebarPayload: MergedHeaderPayload = {aboutData: sidebarAbout, queryKey: sidebarAboutQueryKey}

  return (
    <BranchAndTagCountProvider count={branchAndTagCount}>
      <RecentlyTouchedBranchesProvider {...recentlyTouchedBranches} refetch={refetchBranches}>
        <SharedPageLayout narrow={false}>
          <CommitInfoProvider commitInfo={commitInfo} error={!!commitInfoError} loading={commitInfoLoading}>
            <LatestCommitProvider latestCommit={latestCommit} error={latestCommitError} isLoading={latestCommitLoading}>
              <ReposOverviewPage payload={payload} isTree={false} sidebarPayload={sidebarPayload} />
            </LatestCommitProvider>
          </CommitInfoProvider>
        </SharedPageLayout>
      </RecentlyTouchedBranchesProvider>
    </BranchAndTagCountProvider>
  )
}
